import { render, staticRenderFns } from "./EnacAtplDashboardPhaseLearnerItemDetails.vue?vue&type=template&id=5dfe7a64&scoped=true"
import script from "./EnacAtplDashboardPhaseLearnerItemDetails.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardPhaseLearnerItemDetails.vue?vue&type=script&lang=js"
import style0 from "./EnacAtplDashboardPhaseLearnerItemDetails.vue?vue&type=style&index=0&id=5dfe7a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfe7a64",
  null
  
)

export default component.exports